module.exports = __webpack_public_path__ + "img/welcome-icon-01.76445586.png";